const DefaultProps = {
    interactorSettings: [
        {
            button: 1,
            action: 'Rotate',
        },
        {
            button: 2,
            action: 'Pan',
        },
        {
            button: 3,
            action: 'Zoom',
            scrollEnabled: true,
        },
        {
            button: 1,
            action: 'Pan',
            alt: true,
        },
        {
            button: 1,
            action: 'Zoom',
            control: true,
        },
        {
            button: 1,
            action: 'Select',
            shift: true,
        },
        {
            button: 1,
            action: 'Roll',
            alt: true,
            shift: true,
        },
    ],
    autoCenterOfRotation: true,
};

export { DefaultProps };
